import smartParkService from "../axios";

export const loginService = async (payloadObj) => {
  try {
    const response = await smartParkService.post("api/auth/login", {
      ...payloadObj,
    });
    const { data } = response;
    console.log("data", data);

    if (data.data.IsEnable === "false") {
      alert("User Disabled. Contact administrator.");
      throw new Error("User Disabled. Contact administrator.");
    }

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
